export * from "ce/sagas/draftSages";
import {
  approveTaskSaga,
  cancelProcessApplicationSaga,
  commentTaskSaga,
  createProcessDesignSaga,
  deleteProcessDesignSaga,
  getProcessApplicationDetailsSaga,
  getProcessApplicationListSaga,
  getProcessDesignDetailsSaga,
  getProcessDesignSaga,
  getTaskDetailsSaga,
  getTaskListSaga,
  rejectTaskSaga,
  startApprovalProcessSaga,
  transferTaskSaga,
  updateProcessDesignSaga,
} from "ce/sagas/ApprovalProcess/ProcessDesignSagas";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import { all, takeLatest } from "redux-saga/effects";

export default function* processDesignSagas() {
  yield all([
    takeLatest(
      ReduxActionTypes.AF_FETCH_PROCESS_DESIGN_INIT,
      getProcessDesignSaga,
    ),
    takeLatest(
      ReduxActionTypes.AF_FETCH_PROCESS_DESIGN_DETAILS_INIT,
      getProcessDesignDetailsSaga,
    ),
    takeLatest(
      ReduxActionTypes.AF_CREATE_PROCESS_DESIGN_INIT,
      createProcessDesignSaga,
    ),
    takeLatest(
      ReduxActionTypes.AF_UPDATE_PROCESS_DESIGN_INIT,
      updateProcessDesignSaga,
    ),
    takeLatest(
      ReduxActionTypes.AF_DELETE_PROCESS_DESIGN_INIT,
      deleteProcessDesignSaga,
    ),
    takeLatest(
      ReduxActionTypes.AF_FETCH_PROCESS_APPLICATION_LIST_INIT,
      getProcessApplicationListSaga,
    ),
    takeLatest(
      ReduxActionTypes.AF_FETCH_PROCESS_APPLICATION_DETAILS_INIT,
      getProcessApplicationDetailsSaga,
    ),
    takeLatest(
      ReduxActionTypes.AF_START_PROCESS_APPLICATION_INIT,
      startApprovalProcessSaga,
    ),
    takeLatest(
      ReduxActionTypes.AF_CANCEL_PROCESS_APPLICATION_INIT,
      cancelProcessApplicationSaga,
    ),
    takeLatest(ReduxActionTypes.AF_FETCH_TASK_LIST_INIT, getTaskListSaga),
    takeLatest(ReduxActionTypes.AF_FETCH_TASK_DETAILS_INIT, getTaskDetailsSaga),
    takeLatest(ReduxActionTypes.AF_APPROVE_TASK_INIT, approveTaskSaga),
    takeLatest(ReduxActionTypes.AF_REJECT_TASK_INIT, rejectTaskSaga),
    takeLatest(ReduxActionTypes.AF_TRANSFER_TASK_INIT, transferTaskSaga),
    takeLatest(ReduxActionTypes.AF_COMMENT_TASK_INIT, commentTaskSaga),
  ]);
}
